'use client';
import { isFunction } from '../../guards/isFunction/isFunction.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _create_for_of_iterator_helper_loose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupported_iterable_to_array(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) {
                return {
                    done: true
                };
            }
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/**
 * Производит группировку объектов по ключу или по переданному условию.
 *
 * @param data - Однородный массив объектов произвольной структуры,
 * над которыми будет выполняться группировка.
 * @param condition - Ключ, по значениям которого будет выполняться группировка, либо функция,
 * определяющая, к какой группу должен быть отнесён тот или иной объект.
 *
 * @example Группировка объектов по значению для указанного ключа.
 * ```ts
 * groupBy(
 *     [
 *         { a: 'b', b: 0 },
 *         { a: 'b', b: 0 },
 *         { a: 1, b: 42 },
 *     ],
 *     'a',
 * )
 * /* {
 *  *   [1]: [{ a: 1, b: 42 }],
 *  *   b: [
 *  *       { a: 'b', b: 0 },
 *  *       { a: 'b', b: 0 },
 *  *   ],
 *  * }
 *  * /
 * ```
 *
 * @example Группировка по условию.
 * ```
 * groupBy(
 *     [{ a: 1 }, { a: -1 }, { a: 2 }],
 *     item => item > 0 ? 'positive' : 'negative',
 * )
 * /* {
 *  *   positive: [{ a: 1 }, { a: 2 }],
 *  *   negative: [{ a: -1 }],
 *  * }
 *  * /
 * ```
 *
 * @unstable
 * */ var groupBy = function(data, condition) {
    if (!data) {
        return {};
    }
    var groups = {};
    var splitter = isFunction(condition) ? function(item) {
        return condition(item);
    } : function(item) {
        return item[condition];
    };
    for(var _iterator = _create_for_of_iterator_helper_loose(data), _step; !(_step = _iterator()).done;){
        var item = _step.value;
        var category = splitter(item);
        if (!groups[category]) {
            groups[category] = [];
        }
        groups[category].push(item);
    }
    return groups;
};

export { groupBy };
